import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CssBaseline from '@material-ui/core/CssBaseline'
import withStyles from '@material-ui/core/styles/withStyles'
import ClockComponent from './ClockComponent'
import LoginFormComponent from './LoginFormComponent'
import CustomizedSnackbars from '../Common/CustomizedSnackbars'

import Progress from '../Common/Progress'
import { userActions } from '../../_actions'
import { connect } from 'react-redux'
import { compose } from 'recompose'

const styles = theme => ({
  layout: {
    width: 'auto',
    height: '100vh',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    paddingTop: '150px'
  }
})

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openPage: false,
      snackbarOpen: false,
      openProgress: false
    }

    this.handlePageClick = this.handlePageClick.bind(this)
    this.handleSubmitClick = this.handleSubmitClick.bind(this)
    this.handleSnackBarClose = this.handleSnackBarClose.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (
      !nextProps.authentication.loggedIn &&
      nextProps.authentication.type === 'USERS_LOGIN_FAILURE'
    ) {
      this.setState({
        snackbarOpen: true,
        openProgress: false
      })

      setTimeout(() => {
        this.setState({
          snackbarOpen: false
        })
      }, 3000)
    }
  }

  handlePageClick = () => {
    //導入SSO
    this.setState({
      openPage: true
    })

    this.props.handleCallBack()
  }

  handleSubmitClick(state) {
    const { username, password } = state
    const { dispatch } = this.props

    this.setState({
      openProgress: true
    })

    if (username && password) {
      dispatch(userActions.login(username, password))
    }
  }

  handleSnackBarClose = () => {
    this.setState({
      snackbarOpen: false
    })
  }

  render() {
    const { classes } = this.props

    return (
      <React.Fragment>
        <CssBaseline />
        <Progress openProgress={this.state.openProgress} />{' '}
        <main className={classes.layout}>
          {' '}
          {!this.state.openPage ? (
            <ClockComponent handlePageClick={this.handlePageClick} />
          ) : (
              <LoginFormComponent handleSubmitClick={this.handleSubmitClick} />
            )}{' '}
          <CustomizedSnackbars
            open={this.state.snackbarOpen}
            close={this.handleSnackBarClose}
            snackbarMessage="Wrong Username or Password"
          />
        </main>{' '}
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  const authentication = state.authentication
  return {
    authentication
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, {
    withTheme: true
  })
)(App)



// WEBPACK FOOTER //
// ./src/components/LoginPage/App.js